module.exports = __webpack_public_path__ + "img/BIT_white01.7bdd1d4d.jpg";